module.exports = " <div class=\"chart-container\"> <canvas id=\"{{vm.chartid}}\"></canvas> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-bar-charts/dv-bar-charts.html
// module id = Gh6o
// module chunks = 0